import { render, staticRenderFns } from "./AssignedBranchesComponent.vue?vue&type=template&id=4a99227a&scoped=true"
import script from "./AssignedBranchesComponent.vue?vue&type=script&lang=js"
export * from "./AssignedBranchesComponent.vue?vue&type=script&lang=js"
import style0 from "./AssignedBranchesComponent.vue?vue&type=style&index=0&id=4a99227a&prod&scoped=true&lang=css"
import style1 from "./AssignedBranchesComponent.vue?vue&type=style&index=1&id=4a99227a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99227a",
  null
  
)

export default component.exports